import { render, staticRenderFns } from "./searchId.vue?vue&type=template&id=45af2d49"
import script from "./searchId.vue?vue&type=script&lang=js"
export * from "./searchId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports